import {ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {SignUpService} from "../../services/sign-up.service";
import {SignUpTo} from "../../classes/sign-up-to";
import {Router} from "@angular/router";

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {

  errorMessage: string;
  errorCode: string;
  accountActivationAttempts = 0;

  @ViewChild('activationCode', { static: false }) activationCode: ElementRef;

  resentInd = false;

  signUpTO: SignUpTo;

  confirmationForm = new FormGroup({
    activationCode: new FormControl('', Validators.required),
  });

  constructor(private  signUpService: SignUpService, private router: Router, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.signUpTO = this. signUpService.signUpTO;
    if (!this.signUpTO || !this.signUpTO.email || this.signUpTO.email.length == 0) {
      this.router.navigateByUrl('signup');
    }
    this.changeDetectorRef.detectChanges();
    if (this.activationCode) this.activationCode.nativeElement.focus();
  }

  onActivateAccount() {
    console.log('onActivateAccount...');


    this.signUpTO.registrationKey = this.confirmationForm.value.activationCode;
    this.signUpService.verifySignUp(this.signUpTO).subscribe(data => {
      // console.log('%c this. signUpService.verifySignup:', 'background: #222; color: #bada55');
      // console.dir(data);
      const signUpTO: SignUpTo = <SignUpTo> data;
      if (signUpTO.success) {
        this. signUpService.signUpTO = signUpTO;
        this.router.navigateByUrl('dashboard');
      } else {
        this.errorMessage = 'Failed to verify your activation code.';
        this.errorCode = 'generic';
        if (signUpTO.message && signUpTO.message.length > 0) {
          this.errorMessage = signUpTO.message;
        }
      }


    })
  }

  onResendCode() {
    console.log('onResendCode');
    this.signUpService.resendActivationCode(this.signUpTO).subscribe(data => {
      console.log('%c this. signUpService.resendActivationCode:', 'background: #222; color: #bada55');
      console.dir(data);
      const signUpTO: SignUpTo = <SignUpTo> data;
      if (signUpTO.success) {
        this.resentInd = true;

        setTimeout(() => {
          this.resentInd = false;
        }, 5000);

      } else {
        this.errorMessage = 'Failed to resend your activation code.';
        this.errorCode = 'generic';
        if (signUpTO.message && signUpTO.message.length > 0) {
          this.errorMessage = signUpTO.message;
        }
      }


    })

  }
}
